import React from 'react';
import { useTranslation } from 'react-i18next';

const LoadingSpinner = ({ size = 'md', text, className = '' }) => {
  const { t } = useTranslation();

  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20'
  };

  const spinnerStyle = {
    width: size === 'sm' ? '24px' : size === 'md' ? '40px' : size === 'lg' ? '64px' : '80px',
    height: size === 'sm' ? '24px' : size === 'md' ? '40px' : size === 'lg' ? '64px' : '80px'
  };

  return (
    <div className={`loading-spinner ${className}`}>
      <div className="d-flex flex-column align-center gap-md">
        <div 
          className="spinner"
          style={spinnerStyle}
        />
        {text && (
          <p className="text-secondary m-0">{text}</p>
        )}
        {!text && (
          <p className="text-secondary m-0">{t('common.loading')}</p>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;
